var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",class:_vm.className},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v("鲁ICP备2025188245号-1")]),_c('p',[_vm._v("© 2025 山东省二级建造师继续教育平台. All rights reserved.")]),_c('p',[_vm._v("济南鲁凝教育咨询服务有限公司")]),_c('p',[_vm._v("地址：山东省济南市历下区仁恒世纪花园2号楼101")])])
}
var staticRenderFns = []

export { render, staticRenderFns }